import firebase from "firebase/app";
import "./firebaseConfig";

export default {
  api_keys: {
    uploadcare: "b84367cf8636092ee2f9",
    googlemaps: "AIzaSyCrc0baCX0zXxDU88bjf92KUJdn0qchIWg"
  },
  errors: {
    "auth/invalid-email": "Entered email is invalid",
    "auth/user-disabled": "This user account has been disabled",
    "auth/user-not-found": "We couldn't find an account with this email",
    "auth/wrong-password": "Invalid email/password combination",
    "auth/email-already-in-use": "This email is already in use, please log in",
    "auth/operation-not-allowed":
      "Sorry, you cannot create an account at this time",
    "auth/weak-password": "Your password must be at least 6 characters",
    fill_fields: "Please fill in all the fields",
    password_match: "Your passwords do not match, please re-enter them",
    email: "Error in sending email",
    settings_error: "There was an error in updating your profile",
    payment: "An error ocurred and we could not process your payment",
    card_error: "An error ocurred in saving your card (invalid card)",
    card_delete_error: "An error ocurred in deleting your card",
    subscription_error: "An error ocurred in creating your subcription",
    subscription_cancel_error:
      "An error ocurred in cancelling your subcription",
    subscription_reactivation_error:
      "An error ocurred in reactivating your subcription",
    privilege_error: "An error ocurred in changing the user privileges",
    download_pdf_error: "An error ocurred in downloading your invoice",
    fetch_by_email_error: "We couldn't find a user with this email",
    add_user_error: "An error ocurred in adding this user to your subscription",
    remove_user_error:
      "An error ocurred in removing this user from your subscription"
  },
  info: {
    verify_email:
      "Please verify your email by clicking on the link in your inbox",
    logged_out: "You have been successfully logged out",
    sending_reset: "Sending reset link...",
    sent_reset: "Your password reset link has been sent",
    profile_updated: "Your profile has been updated",
    billing_info_updated: "Your billing details have been updated",
    payment: "Please wait while we verify your payment details...",
    thanks:
      "Thank you for your order! Someone from our team will be in touch shortly.",
    sent: "Sent!",
    card_delete_confirm: "Are you sure you want to delete your card?",
    subscription_cancel_confirm:
      "Are you sure you want to cancel your subscription?",
    card_added: "Your card has been added",
    card_updated: "Your card has been updated",
    card_deleted: "Your card has been deleted",
    subscription_created: "Subscription created successfully",
    subscription_deleted: "Subscription cancelled successfully",
    subscription_updated: "Subscription updated successfully",
    subscription_reactivated: "Subscription reactivated successfully",
    user_added: "User added successfully",
    access_revoked: "Access has been revoked from user",
    role_edited: "User role changed successfully"
  },
  actions: {
    send_reset: "Send reset link"
  },
  profile: {
    default_user_image:
      "https://ucarecdn.com/1cc06c4c-cb90-4ce2-a8ce-520291e651d5/defaultprofile.png"
  },
  urls: {
    apiContact: "https://usebasin.com/f/c0fe176644b1.json",
    functionsBase: `https://us-central1-${
      firebase.app().options.projectId
    }.cloudfunctions.net/`,
    gMapsStaticBase: "https://maps.googleapis.com/maps/api/staticmap",
    gMapsDimenctionBase:
      "https://maps.googleapis.com/maps/api/distancematrix/json",
    blueMarker: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",
    greenMarker: "https://maps.google.com/mapfiles/ms/icons/green-dot.png"
  },
  monthNames: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  fileExts: {
    ".bplx": ".bplx",
    ".kml": ".kml",
    ".kmz": ".kmz"
  },
  markerFilters: {
    plan: {
      _id: "plan",
      imageUrl: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",
      label: "Plan"
    },
    asbuilt: {
      _id: "asbuilt",
      imageUrl: "https://maps.google.com/mapfiles/ms/icons/green-dot.png",
      label: "As-built"
    }
  },
  dataNames: {
    subscriptions: {
      subscriptions: "subscriptions",
      user: {
        id: "id",
        role: "role"
      },
      type: {
        type: "type",
        free: "free",
        paid: "paid"
      },
      cancelled: "cancelled"
    },
    users: {
      users: "users"
    },
    userRoles: {
      uid: "uid",
      sid: "sid",
      role: "role",
      roles: {
        admin: "admin",
        manager: "manager",
        member: "member"
      },
      userRoles: "userRoles"
    },
    geoFences: {
      geoFences: "geoFences",
      sid: "sid",
      name: "name",
      addedBy: "addedBy",
      createdOn: "createdOn",
      polygon: "polygon"
    },
    jobs: {
      jobs: "jobs",
      name: "name",
      sid: "sid",

      isImported: "isImported",
      importStatus: "importStatus",
      originalFileUrl: "originalFileUrl",
      importFileExt: "importFileExt",
      uploadedAt: "uploadedAt",
      importCompletedAt: "importCompletedAt",
      importFiledownloadUrl: "importFiledownloadUrl",

      // collections
      waypointList: "waypointList",
      pointContainerList: "pointContainerList",

      importStatuses: {
        uploaded: "Uploaded",
        imported: "Imported"
      }
    },
    waypointList: {
      position: {
        position: "position",
        coords: {
          coords: "coords"
        }
      }
    }
  }
};
